export enum DateFilterTypes {
    Common = 0,
    NewLeave = 1,
    Discharge = 2,
    Communication = 3,
    FechaRevision = 4,
    Registro = 5,
    PeriodoDeBaja = 6
}
